const videos = () => {
    const sectionsHero = document.querySelectorAll('.hero.variant-four.video-variant');
    const sectionsVideo = document.querySelectorAll('.video-section');
    const columnsContentVideo = document.querySelectorAll('.columns-content.section-with-video');

    function hasParentWithClass(element, className) {
        while (element) {
            if (element.classList.contains(className)) {
                return element;
            }
            element = element.parentElement;
        }
        return null;
    }

    if (sectionsHero.length > 0 || sectionsVideo.length > 0 || columnsContentVideo.length > 0) {

        document.addEventListener('click', (event) => {
            let target = event.target;

            if (target.classList.contains('snd-js-video-player') || target.closest('.snd-js-video-player')) {
                event.preventDefault();
                const parentElement = hasParentWithClass(target, 'snd-js-video-player') || target;
                const video = parentElement.querySelector('.snd-js-video');

                if (!video) return;
                const isActive = video.classList.contains('active');

                if (video.tagName !== "VIDEO" && !isActive) {
                    video.classList.add('active');
                    return;
                }

                const isPlay = video.classList.contains('play');

                setTimeout(() => {
                    if (isActive && isPlay) {
                        !video.paused && video.pause();
                        video.classList.remove('play');
                        return;
                    }

                    if (isActive && !isPlay) {
                        video.paused && video.play();
                        video.classList.add('play');
                        return;
                    }

                    video.classList.add('active', 'play');
                    video.paused && video.play();

                }, 100);
            }
        });
    }
};

export default videos;



// WEBPACK FOOTER //
// ./scripts/modules/videos.js